import Vue from 'vue'
import VueResource from 'vue-resource'
import datePicker from '../../component/dccore-form/datePicker.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import VueNumericInput from 'vue-numeric-input'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import ErrorBlock from '../../component/simple-form/ErrorBlock.vue'
import moment from 'moment'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import toastr from '../toastr'

if ($('#globalpricelist_form').length) {
  let entityId = $('#entity_id').val()
  if (typeof entityId === 'undefined') {
    entityId = null
  }
  Vue.use(VueResource)
  new Vue({
    el: '#globalpricelist_form',
    components: {
      datePicker,
      RingLoader,
      VueNumericInput,
      Singleselect,
      ErrorBlock,
      NumberInput
    },
    data: {
      loading: 0,
      brands: [],
      entityId: entityId,
      errors: {},
      entity: {
        brand: null,
        dateFrom: moment().format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
        deliveryStandard: null,
        deliveryAdditionallyPaid: null,
        packageChangeForMealRatio: null,
        packageChangeForRemainingMealsInDietRatio: null,
        packageChangeForBagRatio: null,
        packageChangeForDietRatio: null,
      }
    },
    watch: {
      'entity.deliveryStandard': function () {
        this.errors.deliveryStandard = null
      },
      'entity.deliveryAdditionallyPaid': function () {
        this.errors.deliveryStandard = null
      },
      'entity.packageChangeForMealRatio': function () {
        this.errors.packageChangeForMealratio = null
      },
      'entity.packageChangeForRemainingMealsInDietRatio': function () {
        this.errors.packageChangeForRemainingMealsInDietRatio = null
      },
      'entity.packageChangeForBagRatio': function () {
        this.errors.packageChangeForBagRatio = null
      },
      'entity.packageChangeForDietRatio': function () {
        this.errors.packageChangeForDietRatio = null
      },
      'entity.dateFrom': function () {
        delete this.errors.dateFrom
      },
      'entity.dateTo': function () {
        delete this.errors.dateTo
      },
      'entity.brand': function () {
        delete this.errors.brand
      }
    },
    mounted() {
      this.getBrands()
      if (this.entityId !== null) {
        this.getEntity()
      }
    },
    methods: {
      round(number) {
        return Math.round(number * 100) / 100
      },
      updateGlobalPriceList(closeAfter) {
        this.errors = {}
        this.loading++
        let route = Routing.generate('api_patch_global_price_list', { priceList: this.entityId })
        this.$http.patch(route, this.entity).then(() => {
          this.loading--
          if (closeAfter === 1) {
            window.location.href = Routing.generate('global_price_list_grid')
          } else {
            toastr.success(Translator.trans('form.updated'))
          }
        }, response => {
          this.errors = response.body.errors
          this.loading--
        })
      },
      createGlobalPriceList() {
        this.errors = {}
        this.loading++
        let route = Routing.generate('api_post_global_price_list')
        this.$http.post(route, this.entity).then(() => {
          this.loading--
          window.location.href = Routing.generate('global_price_list_grid')
        }, response => {
          this.errors = response.body.errors
          this.loading--
        })
      },
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getEntity() {
        this.loading++
        let url = Routing.generate('api_get_global_price_list', { priceList: this.entityId })
        this.$http.get(url).then(response => {
          this.entity = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      }
    }
  })
}
